import React from 'react';
import cn from 'classnames';
import { StaticImageData } from 'next/image';
import Image from '@/Framework/Router/Next/Image';
import styles from './awards.scss';
import shadowStyles from '@dealroadshow/uikit/core/styles/helpers/shadowOnHover.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';

import { awardDescription, awardsCollection, awardsTitle } from './constants';

interface IAward {
  key: string,
  logo: StaticImageData,
  text: string,
  alt: string,
}

interface IProps {
  title?: string,
  description?: string,
  collection?: IAward[],
  className?: string,
  descriptionClassName?: string,
  cardsClassName?: string,
  titleClassName?: string,
}

const Awards = (props: IProps) => {
  const {
    title = awardsTitle,
    description = awardDescription,
    collection = awardsCollection,
    className = '',
    descriptionClassName = '',
    cardsClassName = '',
    titleClassName = '',
  } = props;
  const renderAwardItem = (item) => (
    <div className={ cn(styles.award, shadowStyles.darkShadowOnHover) } key={ item.key }>
      <div className={ cardStyles.cardContainer }>
        <div className={ styles.awardLogo }>
          <Image src={ item.logo } width="140" height="130" alt={ item.alt } />
        </div>
        <div className={ styles.awardText }>
          { item.text }
        </div>
      </div>
    </div>
  );

  return (
    <div className={ cn(styles.awards, className) }>
      <div className={ styles.container }>
        <div className={ cn(styles.sectionTitle, titleClassName) }>{ title }</div>
        <div className={ cn(styles.sectionDescription, descriptionClassName) }>{ description }</div>
      </div>
      <div className={ cardsClassName }>
        { collection.map(renderAwardItem) }
      </div>
    </div>
  );
};

export default Awards;
